import { TranslatePipe } from "@ngx-translate/core";

import { ChangeDetectionStrategy, Component, computed, inject } from "@angular/core";

import { FormatDurationPipe } from "../../../helpers/datehelper/duration";
import { AuthService } from "../../../services/authservice";

@Component({
  selector: "selfservice-authentication-box",
  templateUrl: "selfservice-authentication-box.html",
  styleUrl: "selfservice-authentication-box.scss",
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [TranslatePipe, FormatDurationPipe],
})
export class SelfserviceAuthenticationBox {
  private auth = inject(AuthService);

  protected selfServiceStarted = computed(() => this.auth.selfServiceStarted());
  protected tokenValidFor = computed(() => this.auth.selfServiceTokenValidFor());
}
